<template>
 <div>
   <v-container class="pt-0 pb-0" v-if="sidebar.items.searchBar">
     <search-form class="pt-0 pb-0" />
   </v-container>
   <info-box v-if="sidebar.items.infoBox" />
   <latest-posts-sidebar v-if="sidebar.items.latestPosts" />
   <sidebar-boxes />
   <categories-cloud :min-count="categoriesCloudMinCount" v-if="sidebar.items.categoriesCloud" />
   <tag-cloud :min-count="tagCloudMinCount" v-if="sidebar.items.tagCloud" />
   <sidebar-links />
 </div>
</template>
<script>
  import SearchForm from './SearchForm.vue'
  import InfoBox from './InfoBox.vue'
  import SidebarLinks from './SidebarLinks.vue'
  import SidebarBoxes from './SidebarBoxes.vue'
  import CategoriesCloud from './CategoriesCloud.vue'
  import TagCloud from './TagCloud.vue'
  import LatestPostsSidebar from './LatestPostsSidebar.vue'

  export default {
    name: 'NavigationBarItems',
    components: {
      SearchForm,
      InfoBox,
      SidebarLinks,
      SidebarBoxes,
      CategoriesCloud,
      TagCloud,
      LatestPostsSidebar
    },
    data () {
      return {
        infoBoxData: this.$store.getters.getInfoBox,
        sidebar: this.$store.getters.sidebar,
        categoriesCloudMinCount: this.$store.state.categoriesCloudMinCount,
        tagCloudMinCount: this.$store.state.tagCloudMinCount
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NavigationBarItems.vue